export const GET_ROLE_REQUEST = "GET_ROLE_REQUEST";
export const GET_ROLE_SUCCESS = "GET_ROLE_SUCCESS";
export const GET_ROLE_FAILURE = "GET_ROLE_FAILURE";

export const PATCH_ROLE_REQUEST = "PATCH_ROLE_REQUEST";
export const PATCH_ROLE_SUCCESS = "PATCH_ROLE_SUCCESS";
export const PATCH_ROLE_FAILURE = "PATCH_ROLE_FAILURE";
